import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import logoImage from "../assets/images/logo-white.png";
import btnGooglePlayImage from "../assets/images/btn-google-play@2x.png";
import btnAppStoreImage from "../assets/images/btn-app-store@2x.png";
import { Content, Footer, Header } from "antd/lib/layout/layout";
import MenuLang from "../components/Menus/MenuLang";
import MenuAdmin from "../components/Menus/MenuAdmin";
import { translate } from "../locale";
import PropTypes from "prop-types";

const terms_url = process.env.REACT_APP_TERMS_OF_USE;
const privacy_url = process.env.REACT_APP_PRIVACY_POLICY;

const DefaultLayout = ({ onLogout }) => {
  const handleClickGooglePlay = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.adium.motivia.app"
    );
  };

  const handleClickAppStore = () => {
    window.open("https://apps.apple.com/ar/app/adiumconvoz/id6757407683");
  };

  return (
    <Layout className="bg-white" style={{ minHeight: "100vh" }}>
      <Header className="h-16 bg-custom_primary">
        <div className="max-w-7xl mx-auto h-16 flex flex-row items-center">
          <div className="flex flex-1 flex-row">
            <div className="flex items-center">
              <img src={logoImage} className="h-8" alt="Adium" />
            </div>
          </div>
          {window.innerWidth > 768 && (
            <div>
              <MenuLang />
              <MenuAdmin onLogout={onLogout} />
            </div>
          )}
        </div>
      </Header>

      <Content className="flex justify-center items-start">
        <Outlet />
      </Content>

      <Footer className="h-auto bg-custom_primary">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
          <div className="flex-1">
            <img src={logoImage} className="h-8" alt="Adium" />
          </div>
          <div className="flex-1 flex justify-center gap-4 mt-4 md:mt-0">
            <a
              href={terms_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row items-center text-white hover:!text-gray-300 hover:underline"
            >
              {translate("Términos de uso")}
            </a>
            <span className="text-white">|</span>
            <a
              href={privacy_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row items-center text-white hover:!text-gray-300 hover:underline"
            >
              {translate("Políticas de privacidad y seguridad")}
            </a>
          </div>
          <div className="flex-1 flex justify-end space-x-6 mt-8 md:mt-0">
            <img
              src={btnGooglePlayImage}
              className="h-10 cursor-pointer"
              onClick={handleClickGooglePlay}
              onKeyDown={(e) => e.key === "Enter" && handleClickGooglePlay()}
              alt="Botón Google Play"
            />
            <img
              src={btnAppStoreImage}
              className="h-10 cursor-pointer"
              onClick={handleClickAppStore}
              onKeyDown={(e) => e.key === "Enter" && handleClickAppStore()}
              alt="Botón App Store"
            />
          </div>
        </div>
      </Footer>
    </Layout>
  );
};

DefaultLayout.propTypes = {
  onLogout: PropTypes.func,
};

export default DefaultLayout;
